export const environment = {
  environment: "production",
  refreshApiCallTime: (24 * 60 * 60 * 1000),
  firebaseAuth: false,
  production: true,
  baseUrl: 'https://hirewalks.com/api/v1',
  baseUrl2: 'https://hirewalks.com/api/v2',
  baseUrl3: 'https://hirewalks.com/api/v3',
  server: 'https://portal.hirewalks.com/',
  ulrToDisplayImage: 'https://hirewalks.com/api/v1/details/imagedisplay/',
  socketURL: 'https://hirewalks.com/api/v1', //for socket connection
  candidateURL: 'https://hirewalks.com',
  recruiterURL: 'https://hirewalks.com/recruiters',
  feedBackUrl: 'https://interview-feedback.hirewalks.com',
  encryptSecretKey: 'vuobnvlkdjvndvjkfnkjdlvndskvlnhuisdvbdslvbdslvbdsvdbuvdvhfvjjvbfjvbf',

  // Base URLs
  hrBasePath: 'https://api-gateway.hirewalks.com/vendor',
  jobsBasePath: 'https://api-gateway.hirewalks.com/jobs-api',
  jobsAtsBasePath: 'https://api-gateway.hirewalks.com/jobATS',
  masterBasePath: 'https://api-gateway.hirewalks.com/master',
  chatBasePath: 'https://api-gateway.hirewalks.com/chat',
  offersBasePath: 'https://api-gateway.hirewalks.com/offers',
  subsBasePath: 'https://api-gateway.hirewalks.com/subscription',
  vendorNotifyBasePath: 'https://api-gateway.hirewalks.com/vendorNotifications',
  candBasePath: 'https://api-gateway.hirewalks.com/candidate-api',
  profileBasePath: 'https://api-gateway.hirewalks.com/profileSearch',
  candAuthBasePath: 'https://api-gateway.hirewalks.com/candidateAuth',
  vendorAuthBasePath: 'https://api-gateway.hirewalks.com/vendorAuth',
  devAtsBasePath: 'https://api-gateway.hirewalks.com/jobATS',
  careerPageLink: 'https://careerpage.hirewalks.com/',

  firebaseConfig: {
    apiKey: 'AIzaSyC_kSRScso7HKIAgQOlxwf8i2WMjeHuIvo',
    authDomain: 'hirewalks-16c25.firebaseapp.com',
    projectId: 'hirewalks-16c25',
    storageBucket: 'hirewalks-16c25.appspot.com',
    messagingSenderId: '14576892119',
    appId: '1:14576892119:web:71a6065c5a8055faf21892',
    measurementId: 'G-QWC5TBVDBY',
  },
};
